import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Formik, Field } from 'formik'
import * as yup from "yup"
//redux
import { useDispatch, useSelector } from 'react-redux'
import { listOfBookmarkedProducts } from '../../redux/product/productActions'
import {
    passwordUpdate,
    imageUpdate,
    prfileUpdate,
    prfileInformation,
    listOfPaidInvoices,
    listOfunpaidInvoices,
} from '../../redux/user/userActions'
//MUI
import { makeStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import TextField from "@material-ui/core/TextField"
import AlertMessage from "../../components/Global/Message/Alert";
import MuiAlert from "@material-ui/lab/Alert/Alert";
import Button from "@material-ui/core/Button";
import Modal from '@material-ui/core/Modal';
import Snackbar from "@material-ui/core/Snackbar/Snackbar"
import Backdrop from "@material-ui/core/Backdrop/Backdrop"
import Fade from "@material-ui/core/Fade"
import Hidden from '@material-ui/core/Hidden';
import Visibility from '@material-ui/icons/Visibility'
import InputAdornment from '@material-ui/core/InputAdornment'
//Icons
import PersonIcon from '@material-ui/icons/Person'
import ReceiptIcon from '@material-ui/icons/Receipt'
import BookmarksIcon from '@material-ui/icons/Bookmarks'
import CloseIcon from '@material-ui/icons/Close'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import IconButton from '@material-ui/core/IconButton'
//Page Level Component
import BoxedLayout from '../../layouts/BoxedLayout'
import CustomImageInput from "../../components/Form/CustomImageInput/Index"
import ProductBox from "../../components/Entities/Product/ProductBoxBookmark"
import PaidInvoices from "../../components/Profile/PaidInvoices"
import UnPaidInvoices from "../../components/Profile/UnPaidInvoices"

function TabPanel(props) {

    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );

}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `nav-tab-${index}`,
        'aria-controls': `nav-tabpanel-${index}`,
    };
}

function LinkTab(props) {

    return (
        <Tab
            component="a"
            onClick={(event) => {
                event.preventDefault();
            }}
            {...props}
        />
    );

}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: '#F2F2F2',
        borderRadius: '10px',
        color: '#000',
        padding: '0px',
        margin: '0px',
        width: '100%',
    },
    paperNoBg: {
        backgroundColor: 'transparent',
    },
    container: {
        [theme.breakpoints.up("lg")]: {
            width: 1134
        }
    },
    linkTab: {
        color: '#fff',
        [theme.breakpoints.down("sm")]: {
            fontSize: '0.700rem !important',
        },
    },
    base: {
        flexGrow: 1,
        marginTop: '24px'
    },
    paper: {
        padding: theme.spacing(2),
        backgroundColor: 'transparent !important',
        border: 'none !important',
        boxShadow: 'none'
    },
    green: {
        backgroundColor: "#417557",
        boxShadow: "none",
        color: "#fff",
        width: "140px",
        "&:hover": {
            background: "#447557",
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '15px',
            marginRight: '17px'
        },
    },
    btnChangePass: {
        [theme.breakpoints.down('xs')]: {
            marginTop: '15px',
            marginBottom: '15px',
        }
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: '0px',
    },
    textOrange: {
        color: "#FF9C09",
        cursor: "pointer",
        fontWeight: "bold",
    },
    paperModal: {
        width: "470px",
        background: "#F9F9F9",
        boxSizing: "border-box",
        borderRadius: " 10px",
        paddingTop: '0px',
        outline: "none",

        [theme.breakpoints.down(650)]: {
            width: "85%",
        },
        [theme.breakpoints.up(2560)]: {
            width: "999px",
        },

        [theme.breakpoints.down(340)]: {
            borderTopLeftRadius: "15px",
            borderTopRightRadius: "15px",
            paddingLeft: "10px",
            paddingRight: "10px",
        },
    },
    formC: {
        [theme.breakpoints.up('sm')]: {
            marginTop: "8px",
            paddingRight: '40px'
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1),
            margin: theme.spacing(1),
        },
    },
    modalContainer: {
        padding: theme.spacing(2, 4, 3),
        paddingLeft: "25px",
        paddingBottom: "50px",
        paddingRight: "25px",
    },
    mainProfileContainer: {
        width: '100%',
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(2),
            margin: theme.spacing(2),
        },
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(0),
            margin: theme.spacing(0),
        },
    },
    mainContiner: {
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(3),
            margin: theme.spacing(3),
        },
        [theme.breakpoints.down("sm")]: {
            padding: '0',
            margin: '0',
        },
    },
    appbar: {
        padding: '2px',
    },
    tabs: {
        backgroundColor: '#fff !importanti'
    }
}));


const UserProfile = ({ location, history, match, tab }) => {

    const classes = useStyles()
    const dispatch = useDispatch()

    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });
    const bookmaredProductsList = useSelector(state => state.bookmaredProductsList)
    const profileInformation = useSelector(state => state.profileInformation)

    const {
        loading,
        fullName,
        imageURL,
        mobileNumber,
    } = profileInformation

    const {
        bLoading,
        bookmarks,
    } = bookmaredProductsList

    const paidInvoicesState = useSelector(state => state.paidInvoicesList)
    const {
        paidInvoicesLoading,
        paidInvoices,
    } = paidInvoicesState

    const unpaidInvoicesState = useSelector(state => state.unpaidInvoicesList)
    const {
        unpaidInvoicesLoading,
        unpaidInvoices,
    } = unpaidInvoicesState


    const profileUpdateRequest = useSelector(state => state.profileUpdateRequest)
    const userPasswordUpdate = useSelector(state => state.userProfilePasswordUpdate)
    const userProfileImageUpdate = useSelector(state => state.userProfileImageUpdate)
    const [profileUpdateRequestActive, setProfileUpdateRequestActive] = useState(false)
    const [imageUpdateRequestActive, setImageUpdateRequestActive] = useState(false)
    const [imageUploadBtnText, setImageUploadBtnText] = useState("ذخیره")
    const [passwordUpdateRequestActive, setPasswordUpdateRequestActive] = useState(false)
    const [PageNumber, setPageNumber] = useState('1')
    const [show, setShow] = React.useState(true);
    const [userTokenLocal, setUserTokenLocal] = useState(
        localStorage.getItem("token")
    );

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleClickShowPassword = () => {
        setShow(!show);
    };

    React.useEffect(() => {
        if (typeof profileUpdateRequest !== "undefined") {
            if (profileUpdateRequest.message !== '' && userPasswordUpdate.message !== null && profileUpdateRequest.loading === false) {
                setAlert({ open: true, type: (profileUpdateRequest.status) ? 'success' : 'error', message: profileUpdateRequest.message })
                setProfileUpdateRequestActive(false)
                if (userProfileImageUpdate.status) {
                    setTimeout(function () {
                        window.location.reload(false);
                    }, 1400)
                }
            }
        }
    }, [dispatch, profileUpdateRequest, profileUpdateRequestActive])

    React.useEffect(() => {
        if (typeof userPasswordUpdate !== "undefined") {
            if (userPasswordUpdate.message !== '' && userPasswordUpdate.message !== null && userPasswordUpdate.loading === false) {
                setPasswordUpdateRequestActive(false)
                setAlert({ open: true, type: (userPasswordUpdate.status) ? 'success' : 'error', message: userPasswordUpdate.message })
            }
        }
    }, [dispatch, userPasswordUpdate, passwordUpdateRequestActive])

    React.useEffect(() => {
        if (typeof userProfileImageUpdate !== "undefined") {
            if (userProfileImageUpdate.message !== '' && userPasswordUpdate.message !== null && userProfileImageUpdate.loading === false) {
                setAlert({ open: true, type: (userProfileImageUpdate.status) ? 'success' : 'error', message: userProfileImageUpdate.message })
                setImageUpdateRequestActive(false)
                setImageUploadBtnText("ذخیره")
                if (userProfileImageUpdate.status) {
                    setTimeout(function () {
                        window.location.reload(false);
                    }, 1400)
                }

            }
        }
    }, [dispatch, userProfileImageUpdate, imageUpdateRequestActive])

    useEffect(() => {

        if (tab === "update-information") {
            setCurrentTab(0)
        }
        else if (tab === "unpaid-invoices") {
            setCurrentTab(1)
        }
        else if (tab === "paid-invoices") {
            setCurrentTab(2)
        }
        else if (tab === "bookmarks") {
            setCurrentTab(3)
        }

        if (typeof userTokenLocal !== 'undefined') {

            if (userTokenLocal !== "" && userTokenLocal !== null) {

                dispatch(prfileInformation())

                dispatch(listOfBookmarkedProducts(1))

                dispatch(listOfPaidInvoices(1))

                dispatch(listOfunpaidInvoices(1))

            }
        }

        return history.listen((location) => {
            var loc = location.pathname;
            var res = loc.split("/");
            if (res.length >= 3) {
                if (res[2] === "bookmarks") {
                    setCurrentTab(3)
                } else if (res[2] === "update-information") {
                    setCurrentTab(0)
                }
                else if (res[2] === "unpaid-invoices") {
                    setCurrentTab(1)
                }
                else if (res[2] === "paid-invoices") {
                    setCurrentTab(2)
                }
            }
        })

    }, [dispatch, history])

    const [currentTab, setCurrentTab] = useState(0)
    const [openModal, setOpenModal] = React.useState(false);
    const FILE_SIZE = 160 * 1024 * 160;

    const SUPPORTED_FORMATS = [
        "image/jpg",
        "image/jpeg",
        "image/gif",
        "image/png"
    ];

    const validationSchemImage = yup.object().shape({
        image: yup
            .mixed()
            .test(
                "خطای سایز فایل",
                "سایز فایل بزرگتر از حد مجاز است.",
                value => value && value.size <= FILE_SIZE
            )
            .test(
                "خطای فرمت غیر مجاز",
                "لطفا فایلی با فرمت مجاز انتخاب کنید.",
                value => value && SUPPORTED_FORMATS.includes(value.type)
            ),
    })

    const validationSchema2 = yup.object().shape({
        CurrentPassword: yup.string()
            .required('ورود رمز عبور فعلی اجباری است'),
        NewPassword: yup
            .string()
            .required("لطفا رمز عبور جدید را وارد کنید"),
        // .matches(
        //     /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        //     "رمز عبور باید شامل اعداد ، حروف ، کلمات ویژه و حداقل 8 رقم باشد"
        //),
        NewPasswordVer: yup
            .string()
            .required("تکرار رمز عبور الزامی می باشد")
            .oneOf([yup.ref("NewPassword"), null], "رمز عبور با تکرار آن یکسان نمی باشد."),
    })

    const validationSchema = yup.object().shape({
        fName: yup
            .string("لطفا نام و نام خانوادگی خود را وارد کنید")
            .required("نام و نام خانوادگی الزامی است"),
    });

    const handleChangeTab = (event, newValue) => {
        setCurrentTab(newValue);
    };

    const toggleCloseAlert = () => {
        setAlert({
            open: false,
            type: '',
            message: '',
        })
    };

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    return (
        <>
            <BoxedLayout lang='fa' breadcrumbsItems={
                [{
                    title: 'صفحه اصلی',
                    to: "/"
                },
                {
                    title: 'پروفایل کاربری',
                    to: "/"
                }]}>
                <Grid item xs={12}>
                    <Box boxShadow={0} border={0} p={2} m={2} className={classes.mainProfileContainer + ' profile-tabs'}>
                        <div className={classes.root}>

                            <Tabs
                                variant="fullWidth"
                                value={currentTab}
                                className={classes.tabs}
                                onChange={handleChangeTab}
                                aria-label="nav tabs example">
                                <LinkTab className={classes.linkTab} icon={<PersonIcon />} label="پروفایل کاربری" href="/drafts" {...a11yProps(0)} />
                                <LinkTab className={classes.linkTab} icon={<ReceiptIcon />} label="فاکتورهای پرداخت نشده" href="/trash" {...a11yProps(1)} />
                                <LinkTab className={classes.linkTab} icon={<ReceiptIcon />} label="فاکتورهای پرداختی" href="/spam" {...a11yProps(2)} />
                                <LinkTab className={classes.linkTab} icon={<BookmarksIcon />} label="نشان شده ها" href="/spam" {...a11yProps(3)} />
                            </Tabs>
                            <TabPanel value={currentTab} index={0}>
                                <Grid container style={{ padding: '0' }}>
                                    <Hidden only={['xs']}>
                                        <Grid item md={1} xs={12}>&nbsp;</Grid>
                                    </Hidden>
                                    <Grid item md={10} xs={12}>
                                        <Box evelotion={2} borderRadius={15} className={classes.mainContiner} style={{ backgroundColor: '#fff' }}>
                                            <Grid container spacing={0}>
                                                <Hidden only={['xs']}>
                                                    <Grid item md={1} xs={12}>&nbsp;</Grid>
                                                </Hidden>
                                                <Grid item md={10} xs={12}>
                                                    <Grid container spacing={1}>
                                                        <Grid item md={4} xs={12}>
                                                            <Box boxShadow={0} border={0} p={0} m={1} style={{ textAlign: 'left' }}>
                                                                {(loading === false) && (
                                                                    <Formik
                                                                        initialValues={{
                                                                            image: undefined,
                                                                        }}
                                                                        validationSchema={validationSchemImage}
                                                                        onSubmit={async (values, { setStatus, setSubmitting }) => {
                                                                            setStatus()
                                                                            try {
                                                                                setImageUploadBtnText("در حال ذخیره...")
                                                                                setImageUpdateRequestActive(true)
                                                                                let formData = new FormData()
                                                                                formData.append("Image", values.image)
                                                                                dispatch(imageUpdate(formData))
                                                                            } catch (error) {
                                                                                //console.log(error)
                                                                            }
                                                                        }}
                                                                        render={({ errors, status, touched, handleChange, handleSubmit, handleBlur, setFieldValue, values, isSubmitting }) => (
                                                                            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                                                                                <Field
                                                                                    name="image"
                                                                                    component={CustomImageInput}
                                                                                    type="image"
                                                                                    defaultImage={imageURL}
                                                                                    boxHeight="225px"
                                                                                    btnText={imageUploadBtnText}
                                                                                    btnActivitiy={imageUpdateRequestActive}
                                                                                    setFieldValue={setFieldValue}
                                                                                    errorMessage={errors["image"] ? errors["image"] : undefined}
                                                                                    touched={touched["image"]}
                                                                                    style={{ display: "flex" }}
                                                                                    onBlur={handleBlur}
                                                                                />
                                                                            </form>
                                                                        )}
                                                                    />
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                        <Grid item md={8} xs={12}>
                                                            <Box evelotion={0} mr={0} className={classes.formC}>
                                                                {(loading === false) && (
                                                                    <Formik
                                                                        initialValues={{
                                                                            fName: fullName,
                                                                        }}
                                                                        validationSchema={validationSchema}
                                                                        onSubmit={async (values, { setStatus, setSubmitting }) => {
                                                                            setStatus()
                                                                            try {
                                                                                let formData = new FormData()
                                                                                formData.append("FullName", values.fName)
                                                                                //formData.append("Address", "[ADDRESS]")
                                                                                dispatch(prfileUpdate(formData)).then(() => {
                                                                                    setProfileUpdateRequestActive(true)
                                                                                })
                                                                            } catch (error) {
                                                                                //console.log(error)
                                                                            }
                                                                        }}
                                                                        render={({ errors, status, touched, handleChange, handleSubmit, handleBlur, setFieldValue, values, isSubmitting }) => (
                                                                            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                                                                                <Grid container spacing={0}>
                                                                                    <Grid item xs={12}>
                                                                                        <lable className={classes.label}>نام و نام خانوادگی</lable>
                                                                                        <Box evelotion={0}>
                                                                                            <TextField
                                                                                                fullWidth
                                                                                                name="fName"
                                                                                                variant="outlined"
                                                                                                value={values.fName}
                                                                                                onChange={handleChange}
                                                                                                style={{ marginTop: '10px' }}
                                                                                                error={
                                                                                                    touched.fName && Boolean(errors.fName)
                                                                                                }
                                                                                                helperText={
                                                                                                    touched.fName && errors.fName
                                                                                                }
                                                                                            />
                                                                                        </Box>
                                                                                    </Grid>
                                                                                    <Grid item xs={12} style={{ textAlign: 'right', marginTop: '25px' }}>
                                                                                        <lable className={classes.label}>شماره موبایل</lable>
                                                                                        <Box evelotion={0}>
                                                                                            <TextField
                                                                                                fullWidth
                                                                                                variant="outlined"
                                                                                                value={mobileNumber}
                                                                                                disabled={true}
                                                                                                style={{ marginTop: '10px' }}
                                                                                            />
                                                                                            <Grid container>
                                                                                                <Grid item md={6} style={{ textAlign: 'right' }}>
                                                                                                    <Button
                                                                                                        variant="contained"
                                                                                                        type="button"
                                                                                                        style={{ marginTop: '20px' }}
                                                                                                        onClick={handleOpenModal}
                                                                                                        className={classes.btnChangePass}
                                                                                                        disabled={isSubmitting}>
                                                                                                        تغییر رمز عبور
                                                                                                            </Button>
                                                                                                </Grid>
                                                                                                <Grid item md={6} style={{ textAlign: 'left' }}>
                                                                                                    <Button
                                                                                                        variant="contained"
                                                                                                        type="submit"
                                                                                                        style={{ marginTop: '20px' }}
                                                                                                        disabled={isSubmitting}
                                                                                                        className={classes.green}>
                                                                                                        ذخیره تغییرات
                                                                                                            </Button>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        </Box>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </form>
                                                                        )}
                                                                    />
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Hidden only={['xs']}>
                                                    <Grid item md={1} xs={12}>&nbsp;</Grid>
                                                </Hidden>

                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Hidden only={['xs']}>
                                        <Grid item md={1} xs={12}>&nbsp;</Grid>
                                    </Hidden>
                                </Grid>
                            </TabPanel>
                            <TabPanel value={currentTab} index={1}>
                                {(typeof unpaidInvoicesLoading !== "undefined" && typeof unpaidInvoices !== "undefined") ? (
                                    (!unpaidInvoicesLoading) ? (
                                        (unpaidInvoices.length > 0) ? (
                                            <UnPaidInvoices rows={unpaidInvoices} />
                                        ) : (
                                            <AlertMessage variant="info">
                                                .موردی جهت نمایش وجود ندارد
                                            </AlertMessage>
                                        )
                                    ) : (
                                        <AlertMessage variant="info">
                                            در حال بارگزاری...
                                        </AlertMessage>
                                    )
                                ) : (
                                    <AlertMessage variant="info">
                                        در حال بارگزاری...
                                    </AlertMessage>
                                )}
                            </TabPanel>
                            <TabPanel value={currentTab} index={2}>
                                {(typeof paidInvoicesLoading !== "undefined" && typeof paidInvoices !== "undefined") ? (
                                    (!paidInvoicesLoading) ? (
                                        (paidInvoices.length > 0) ? (
                                            <PaidInvoices rows={paidInvoices} />
                                        ) : (
                                            <AlertMessage variant="info">
                                                .موردی جهت نمایش وجود ندارد
                                            </AlertMessage>
                                        )
                                    ) : (
                                        <AlertMessage variant="info">
                                            در حال بارگزاری...
                                        </AlertMessage>
                                    )
                                ) : (
                                    <AlertMessage variant="info">
                                        در حال بارگزاری...
                                    </AlertMessage>
                                )}
                            </TabPanel>
                            <TabPanel value={currentTab} index={3}>
                                <Grid container spacing={1}>
                                    {(typeof bLoading !== "undefined" && typeof bookmarks !== "undefined") ? (
                                        (!bLoading) ? (
                                            (bookmarks.length > 0) ? (
                                                bookmarks.map((product, i) => (

                                                    <ProductBox
                                                        lang='fa'
                                                        key={i}
                                                        dbid={product.bookmarkId}
                                                        product={product.product}
                                                    />

                                                ))
                                            ) : (
                                                <AlertMessage variant="info">
                                                    .موردی جهت نمایش وجود ندارد
                                                </AlertMessage>
                                            )
                                        ) : (
                                            <AlertMessage variant="info">
                                                در حال بارگزاری...
                                            </AlertMessage>
                                        )
                                    ) : (
                                        <AlertMessage variant="info">
                                            در حال بارگزاری...
                                        </AlertMessage>
                                    )}
                                </Grid>
                            </TabPanel>

                        </div>
                    </Box>

                </Grid>
                <Snackbar
                    open={alert.open}
                    autoHideDuration={4000}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    onClose={toggleCloseAlert}>
                    <Alert onClose={toggleCloseAlert} severity={alert.type}>
                        {alert.message}
                    </Alert>
                </Snackbar>
            </BoxedLayout>
            <Modal
                open={openModal}
                center
                className={classes.modal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}>
                <Fade in={openModal}>
                    <div className={classes.paperModal}>
                        <div className={classes.modalContainer}>
                            <Box evelotion={0} mt={0} style={{ textAlign: 'center' }}>
                                <h3 style={{ marginTop: '0px' }}>تغییر رمز عبور
                                <CloseIcon onClick={handleCloseModal} style={{ float: 'right', cursor: 'pointer' }} />
                                </h3>
                            </Box>
                            <hr />
                            <Formik
                                initialValues={{
                                    CurrentPassword: '',
                                    NewPassword: "",
                                    NewPasswordVer: "",
                                }}
                                validationSchema={validationSchema2}
                                onSubmit={async (values, { setStatus, setSubmitting }) => {
                                    setStatus();
                                    try {
                                        let formData = new FormData()
                                        formData.append("CurrentPassword", values.CurrentPassword)
                                        formData.append("NewPassword", values.NewPassword)
                                        dispatch(passwordUpdate(formData)).then(() => {
                                            setPasswordUpdateRequestActive(true)
                                        })
                                    } catch (error) {
                                        //console.log(error)
                                    }
                                }}
                                render={({ errors, status, touched, handleChange, handleSubmit, handleBlur, setFieldValue, values, isSubmitting }) => (
                                    <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Box px={3} mt={1}>
                                                    <lable className={classes.label} style={{ fontWeight: '700' }}>رمز عبور فعلی</lable>
                                                    <TextField
                                                        fullWidth
                                                        name="CurrentPassword"
                                                        type="password"
                                                        variant="outlined"
                                                        value={values.CurrentPassword}
                                                        style={{ marginTop: '10px' }}
                                                        onChange={handleChange}
                                                        error={
                                                            touched.CurrentPassword &&
                                                            Boolean(errors.CurrentPassword)
                                                        }
                                                        helperText={
                                                            touched.CurrentPassword && errors.CurrentPassword
                                                        }
                                                    />
                                                </Box>
                                                <Box px={3} mt={2}>
                                                    <lable className={classes.label} style={{ fontWeight: '700' }}>رمز عبور جدید</lable>
                                                    <TextField
                                                        dir="ltr"
                                                        type={show ? 'password' : 'text'}
                                                        fullWidth
                                                        name="NewPassword"
                                                        variant="outlined"
                                                        value={values.NewPassword}
                                                        style={{ marginTop: '10px' }}
                                                        onChange={handleChange}
                                                        error={touched.NewPassword && Boolean(errors.NewPassword)}
                                                        helperText={touched.NewPassword && errors.NewPassword}
                                                        InputProps={{
                                                            endAdornment: (<InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    edge="end"
                                                                >
                                                                    {show ? <Visibility /> : <VisibilityOff />}
                                                                </IconButton>
                                                            </InputAdornment>)
                                                        }} />
                                                </Box>
                                                <Box px={3} mt={2}>
                                                    <lable className={classes.label} style={{ fontWeight: '700' }}>تایید رمز عبور</lable>
                                                    <TextField
                                                        dir="ltr"
                                                        type={show ? 'password' : 'text'}
                                                        fullWidth
                                                        name="NewPasswordVer"
                                                        variant="outlined"
                                                        value={values.NewPasswordVer}
                                                        style={{ marginTop: '10px' }}
                                                        onChange={handleChange}
                                                        error={touched.NewPasswordVer && Boolean(errors.NewPasswordVer)}
                                                        helperText={touched.NewPasswordVer && errors.NewPasswordVer}
                                                        InputProps={{
                                                            endAdornment: (<InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    edge="end"
                                                                >
                                                                    {show ? <Visibility /> : <VisibilityOff />}
                                                                </IconButton>
                                                            </InputAdornment>)
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box evelotion={0} style={{ textAlign: 'left', marginTop: '20px' }}>
                                                    <Button
                                                        variant="contained"
                                                        type="submit"
                                                        style={{ marginLeft: '23px' }}
                                                        disabled={passwordUpdateRequestActive}
                                                        className={classes.green}>
                                                        تایید
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            />
                        </div>
                    </div>
                </Fade>
            </Modal>
        </>
    )
}

export default UserProfile
